import ScrollReveal from "../../../components/feature/ScrollReveal";
import { optionsData } from "../../../mocks/pricingData";

export default function OptionsSection() {
  return (
    <section className="py-16 md:py-24 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-10">
              <p className="section-label mb-3">{optionsData.label}</p>
              <h2 className="section-title">{optionsData.title}</h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {optionsData.items.map((item, idx) => (
              <ScrollReveal key={item.name} direction="up" delay={idx * 80}>
                <div className="p-5 bg-white rounded-lg">
                  <h3 className="text-base font-serif font-semibold text-airdoa-navy">{item.name}</h3>
                  <p className="mt-1 text-sm text-airdoa-gray">{item.desc}</p>
                  <p className="mt-3 text-sm font-medium text-airdoa-navy">{item.price}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}